import { gql } from '@apollo/client';
import { DealItemSaleItemPackageFragment } from './DealItemSaleItemPackageFragment';
import { DealItemSaleItemOptionFragment } from './DealItemSaleItemOptionFragment';
/**
 * @fragment DealItemConfigurationFragment
 * @since 1.0.0
 */
export const DealItemConfigurationFragment = gql `
  fragment DealItemConfigurationFragment on DealItemConfiguration {
    id
    quantity
    price
    feeValue
    startTime
    endTime
    priceDisplay
    type
    parent
    proposed
    initiallyProposed
    alternativeTo
    hide
    included
    order
    createdAt
    updatedAt

    fieldValues {
      ...FieldValueFragment
    }

    item {
      ...DealItemSaleItemOptionFragment
    }

    package {
      ...DealItemSaleItemPackageFragment
    }

    priceList {
      id
      title
    }

    relatedItems {
      id
      quantity
      price
      type
      parent
      proposed
    }
  }

  ${DealItemSaleItemOptionFragment}
  ${DealItemSaleItemPackageFragment}
`;
